<template>
  <ClientCreatePassport/>
  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <div v-if="showModal">
      <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog" aria-labelledby="productModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document"
             v-bind:style="currentStep > 1 ? {maxWidth: '800px'} : {maxWidth: '500px'}">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="productModalLabel">{{ this.isEditable ? 'Редактировать' : 'Добавить' }}
                Клиента</h5>
              <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
              </b-button>
            </div>
            <div class="modal-body">
              <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">

                <div v-if="this.clientRequestIsLoading">
                  <CircleProgress/>
                </div>
              </transition>

                <div v-if="currentStep === 1 && !this.clientRequestIsLoading" :key="'step1'">
                  <ClientFirstStep/>
                </div>

                <div v-if="currentStep === 2 && !this.clientRequestIsLoading" :key="'step2'">
                  <ClientSecondStep
                  />
                </div>

                <div v-if="currentStep === 3 && !this.clientRequestIsLoading" :key="'step3'">
                  <ClientThirdStep/>
                </div>


                <div class="form-nav-buttons">
                  <argon-button
                      v-if="(currentStep > 1)"
                      variant="outline"
                      color="primary"
                      class="btn-primary btn"
                      type="button"
                      @click="previousStep"
                      style="margin-top: 5px; margin-bottom: 0;"
                  >Назад
                  </argon-button>

                  <argon-button
                      variant="fill"
                      color="primary"
                      class="btn-primary btn"
                      type="button"
                      @click="this.getNextStage()"
                      style="margin-top: 5px; margin-bottom: 0;"
                  >{{ this.getBtnName() }}
                  </argon-button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import ClientFirstStep from "../ClientSteps/ClientFirstStep.vue";
import ClientSecondStep from "../ClientSteps/ClientSecondStep.vue";
import ClientThirdStep from "../ClientSteps/ClientThirdStep.vue";
import CircleProgress from "../CircleProgress.vue";
import velocity from "velocity-animate";
import axios from "@/axios";
import ClientCreatePassport from "../ClientSteps/ClientCreatePassport.vue";

export default {
  name: 'ClientCreateModal',
  components: {
    ClientCreatePassport,
    CircleProgress,
    ClientFirstStep,
    ClientSecondStep,
    ClientThirdStep,
  },
  props: {
    createClient: Function,
    updateClients: Function,
  },
  data() {
    return {
      passportAuthors: [],
      currentStep: 1,
      clientData: {
        fullName: "",
        birthdate: null,
        isLegalEntity: false,

        phone: null,
        address: null,
        email: null,
        additionalPhone: null,
        passportNumber: null,
        passportIssueDate: null,
        passportIssuingAuthorityId: null,
        passportScan: null,
        registrationAddress: null,
        workInfo: null,
        bankBIC: null,

        companyName: null,
        authorizedPerson: null,
        authorityBasis: null,
        legalAddress: null,
        companyPhone: null,
        unpOrItn: null,
        bankAccount: null,
        invoiceDate: null,

      }
    };
  },
  methods: {

    getBtnName() {
      if (this.isEditable) {
        return "Сохранить";
      } else {
        if (this.currentStep < this.totalSteps) {
          return "Далее";
        } else {
          return "Добавить";
        }
      }
    },

    closeModal() {
      this.$store.commit('updateClientFilterStr', null);
      this.updateClientShowModal(false);
      this.updateClients();
      this.clearClientData();
      this.resetCreationSteps();
      this.setClientIsEditable(false);
    },
    fetchPassportAuthors() {
      axios.get('/api/clients/pasport_autors').then(response => {
        this.setPassportAuthors(response.data);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    setPassportAuthors(passports){
      this.$store.commit('updatePassportAuthors', passports);
    },

    setData() {

      this.clientData.fullName = this.fullName;
      this.clientData.isLegalEntity = this.islegalData;
      this.clientData.birthdate = this.birthday;
      this.clientData.passportIssueDate = this.passportIssueDate;
      this.clientData.phone = this.firstPhone;
      this.clientData.address = this.address;
      this.clientData.email = this.email;
      this.clientData.additionalPhone = this.secondPhone;
      this.clientData.passportNumber = this.passport;
      this.clientData.passportIssuingAuthorityId = this.passportIssuingAuthorityId;
      this.clientData.registrationAddress = this.registrationAddress;
      this.clientData.workInfo = this.workInfo;
      this.clientData.passportScan = this.passportScan;

      if (this.clientData.isLegalEntity) {
        this.clientData.companyName = this.companyName;
        this.clientData.authorizedPerson = this.authorizedPerson;
        this.clientData.authorityBasis = this.authorityBasis;
        this.clientData.legalAddress = this.legalAddress;
        this.clientData.companyPhone = this.companyPhone;
        this.clientData.unpOrItn = this.unpOrItn;
        this.clientData.bankAccount = this.bankAccount;
        this.clientData.invoiceDate = this.invoiceDate;
        this.clientData.bankBIC = this.selectedBankBic;
      }

    },

    getNextStage() {
      console.log("NEXT STEP: " + this.currentStep);
      if (this.isEditable) {
        switch (this.currentStep) {
          case 1:
            this.editClientFirst();
            break;
          case 2:
            this.editClientSecond();
            break;
          case 3:
            this.editClientThird();
            break;
        }
      } else {
        if (this.currentStep < this.totalSteps) {
          this.nextStep();
        } else {
          this.addClient();
        }
      }
    },

    editClientFirst() {
      if (this.fullName !== null && this.fullName !== "") {
        const clientEdit = {
          fullName: this.fullName,
          birthdate: this.birthday,
          isLegalEntity: this.islegalData
        };
        this.updateClientRequestIsLoading(true);
        axios.put(`/api/clients/${this.clientId}`, clientEdit).then(() => {
          this.updateClientRequestIsLoading(false);
          this.updateClients();
          this.nextStep();
        });
      }
    },
    editClientSecond() {
      if (this.fullName !== null && this.fullName !== "") {
        const clientEdit = {
          passportIssueDate: this.passportIssueDate,
          phone: this.firstPhone,
          address: this.address,
          email: this.email,
          additionalPhone: this.secondPhone,
          passportNumber: this.passport,
          passportIssuingAuthorityId: this.passportIssuingAuthorityId,
          registrationAddress: this.registrationAddress,
          workInfo: this.workInfo,
          passportScan: this.passportScan
        };
        this.updateClientRequestIsLoading(true);
        axios.put(`/api/clients/personal-info/${this.personalDataId}`, clientEdit).then(() => {
          this.updateClientRequestIsLoading(false);
          if (this.islegalData) {
            this.nextStep();
          } else {
            this.closeModal();
          }
        });
      }
    },
    editClientThird() {
      if (this.fullName !== null && this.fullName !== "") {
        const clientEdit = {
          companyName: this.companyName,
          authorizedPerson: this.authorizedPerson,
          authorityBasis: this.authorityBasis,
          legalAddress: this.legalAddress,
          companyPhone: this.companyPhone,
          unpOrItn: this.unpOrItn,
          bankAccount: this.bankAccount,
          invoiceDate: this.invoiceDate,
          bankBIC: this.selectedBankBic
        };
        this.updateClientRequestIsLoading(true);
        axios.put(`/api/clients/legal-info/${this.legalDataId}`, clientEdit).then(() => {
          this.updateClientRequestIsLoading(false);

          this.updateClients();

          this.updateClientShowModal(false);
          this.clearClientData();
          this.resetCreationSteps();
        });
      }
    },

    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    nextStep() {
      if (this.currentStep == 1 && this.passportAuthors.length == 0) {
        this.fetchPassportAuthors();
      }
      this.currentStep++;
    },

    addClient() {

      this.setData();

      if (this.clientData.fullName !== null && this.clientData.fullName !== "") {
        this.updateClientRequestIsLoading(true);
        axios.post('/api/clients/client/add', this.clientData).then((response) => {
          this.updateClientRequestIsLoading(false);
          console.log("NAME: ", this.fullName)
          this.$store.commit('updateClientFilterStr', this.fullName);
          this.clearClientData();
          this.updateClientShowModal(false);
          // this.fetchData();
          this.resetCreationSteps();
          this.createClient();
          this.setOrderClient(response.data.data.client_id);
        });
      }
    },
    resetCreationSteps() {
      this.currentStep = 1;
    },
    updateClientShowModal(active) {
      this.$store.commit('updateClientShowModal', active);
    },
    clearClientData() {
      this.$store.commit('clearCreateClient');
    },
    setClientIsEditable(isEditable) {
      this.$store.commit('updateClientIsEditable', isEditable);
    },
    updateClientRequestIsLoading(active) {
      this.$store.commit('updateClientRequestIsLoading', active);
    },
    setOrderClient(payload) {
      this.$store.commit('updateCreateOrderClient', payload);
    },

    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    }

  },
  computed: {
    legalDataId: {
      get() {
        return this.$store.state.legalDataId
      }
    },
    showModal: {
      get() {
        return this.$store.state.clientShowModal
      }
    },
    isEditable: {
      get() {
        return this.$store.state.clientIsEditable;
      }
    },
    clientRequestIsLoading: {
      get() {
        return this.$store.state.clientRequestIsLoading
      }
    },
    fullName: {
      get() {
        return this.$store.state.clientCreateFullName;
      },
    },
    birthday: {
      get() {
        return this.$store.state.clientCreateBirthday;
      },
    },
    personalDataId: {
      get() {
        return this.$store.state.personaDataId
      }
    },
    islegalData: {
      get() {
        return this.$store.state.clientCreateLegalData;
      },
    },
    clientId: {
      get() {
        return this.$store.state.clientId
      }
    },
    passportIssueDate: {
      get() {
        return this.$store.state.clientCreatePassportIssueDate;
      },
    },
    firstPhone: {
      get() {
        return this.$store.state.clientCreateFirstPhone;
      },
    },
    address: {
      get() {
        return this.$store.state.clientCreateAddress;
      },
    },
    email: {
      get() {
        return this.$store.state.clientCreateEmail;
      },
    },
    secondPhone: {
      get() {
        return this.$store.state.clientCreateSecondPhone;
      },
    },
    passport: {
      get() {
        return this.$store.state.clientCreatePassport;
      },
    },
    passportIssuingAuthorityId: {
      get() {
        return this.$store.state.clientCreatePassportIssuingAuthorityId;
      },
    },
    registrationAddress: {
      get() {
        return this.$store.state.clientCreateRegistrationAddress;
      },
    },
    workInfo: {
      get() {
        return this.$store.state.clientCreateWorkInfo;
      },
    },
    passportScan: {
      get() {
        return this.$store.state.clientCreatePassportScan;
      },
    },
    companyName: {
      get() {
        return this.$store.state.clientCreateCompanyName;
      },
    },
    authorizedPerson: {
      get() {
        return this.$store.state.clientCreateAuthorizedPerson
      }
    },
    authorityBasis: {
      get() {
        return this.$store.state.clientCreateAuthorityBasis
      }
    },
    legalAddress: {
      get() {
        return this.$store.state.clientCreateLegalAddress
      }
    },
    companyPhone: {
      get() {
        return this.$store.state.clientCreateCompanyPhone
      }
    },
    unpOrItn: {
      get() {
        return this.$store.state.clientCreateTaxNumber
      }
    },
    bankAccount: {
      get() {
        return this.$store.state.clientCreateBankAccount
      }
    },
    invoiceDate: {
      get() {
        return this.$store.state.clientCreateInvoiceDate
      }
    },
    selectedBankBic: {
      get() {
        return this.$store.state.clientCreateBic
      }
    },
    totalSteps: {
      get() {
        return this.$store.state.clientsTotalSteps;
      }
    },
  },
  mounted() {
    this.fetchPassportAuthors();
  },
};
</script>

<style scoped>
.form-nav-buttons {
  display: flex;
  justify-content: space-between;
}
</style>
